exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    background-color: #F0F0F0;\r\n    display: block;\r\n    /* height: 100px; */\r\n}\r\n.ship-popup-wrapper {\r\n    padding: 15px;\r\n}\r\n\r\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .lfwms-hdr-checkbox {\r\n    display: none;\r\n}\r\n/*\r\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .header-content .icon-sort {\r\n    display: none;\r\n}\r\n\r\n\r\n::ng-deep .ship-popup-wrapper lfwms-result-data-table .header-content .ag-header-row {\r\n    \r\n}\r\n*/\r\n.ship-button {\r\n    margin-left:20px;\r\n}\r\n.detail-back-container {\r\n    background: #F0F0F0;\r\n    padding-top: 10px;\r\n    padding-left: 22px;\r\n}\r\n.lbl-back-prop {\r\n    display: inline-block;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    color: #12408B;\r\n    position: relative;\r\n    bottom: 3px;\r\n}\r\n.forward-backward-icon {\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    color: #12408B; \r\n    margin-left: 18px;   \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-ship-reship-popup/wave-ship-reship-popup.component.css
// module id = ../../../../../src/app/shared/lookup/wave-ship-reship-popup/wave-ship-reship-popup.component.css
// module chunks = main